// Banner.js
import React from 'react';
import '../css/index.css';
const BannerLast = () => {
    
  return (
    <div className='container-last'>
    <div className="banner-last">
        <h1 className='banner-last-h1'>art is limitless</h1>            
    </div>
    </div>
    
  );
};

export default BannerLast;
